import Vue from 'vue'
import Router from 'vue-router'
import Simulator from '@/modules/simulator/Simulator'

Vue.use(Router)



export default new Router({
  mode: 'history',
  base: '/tapete-personalizado-meupet-promo-agosto/custom2/',
  routes: [
    {
      path: '/',
      name: 'simulator',
      component: Simulator
    },
  ],
})
